import type { PdfAdvisorNotePage } from "@repo/shared/types";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api/_client";

const keys = {
  byTemplate: (templateId: string | null) =>
    ["pdf-templates", templateId, "advisor-note-pages"] as const,
};

// One array for "nothing yet", so consumers' memos do not rebuild every render.
const NO_PAGES: PdfAdvisorNotePage[] = [];

/**
 * QL-414 — the pages of a PDF template's flow that take advisor notes: one
 * `{{AdvisorNote.<page>}}` field each in the Insert Field menus. `isUnknown`
 * is true while the list is loading or after its fetch failed: `pages` is then
 * an empty placeholder, which must not read as "no page takes advisor notes".
 */
export function usePdfTemplateAdvisorNotePages(templateId: string | null | undefined) {
  const { data } = useQuery({
    queryKey: keys.byTemplate(templateId ?? null),
    queryFn: () =>
      get<PdfAdvisorNotePage[]>(`/internal/pdf-templates/${templateId}/advisor-note-pages`),
    enabled: !!templateId,
  });
  return { pages: data ?? NO_PAGES, isUnknown: data === undefined };
}
